<main class="relative flex flex-col pt-14 lg:pt-18">
  <div class="relative w-full">
    <img src="/event/top-bg-mo.svg" alt="top background" class="w-full flex lg:hidden" />
    <img src="/event/top-bg-pc.svg" alt="top background" class="w-full hidden lg:flex" />

    <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
      <p class="sb-aggro text-white/40 font-light text-xs">홈 > 행사 안내</p>
      <h1 class="text-white text-2xl lg:text-4xl">행사 안내</h1>
      <p class="text-zinc-400 font-medium">밀리언쇼의 행사안내를 살펴보세요.</p>
    </div>
  </div>

  <!-- 탭 섹션 -->
  <div class="bg-white sticky top-14 lg:top-18 z-10">
    <!-- 탭 스크롤 힌트 래퍼 -->
    <div class="relative">
      <div #tabContainer class="promotion-tabs lg:px-0 lg:max-w-6xl lg:mx-auto" (scroll)="onTabScroll($event)">
        <button
          class="tab sb-aggro text-base font-light px-4!"
          [class.active]="selectedTab() === 'promotion'"
          (click)="changeTab('promotion')">
          홍보 계획
        </button>
        <button
          class="tab sb-aggro text-base font-light px-4!"
          [class.active]="selectedTab() === 'application'"
          (click)="changeTab('application')">
          참가신청 안내
        </button>
        <button
          class="tab sb-aggro text-base font-light px-4!"
          [class.active]="selectedTab() === 'preparation'"
          (click)="changeTab('preparation')">
          참가업체 준비일정
        </button>
        <button
          class="tab sb-aggro text-base font-light px-4!"
          [class.active]="selectedTab() === 'faq'"
          (click)="changeTab('faq')">
          자주 묻는 질문
        </button>
      </div>

      <!-- 우측 스크롤 힌트: 모바일에서만 표시, 끝에 도달하면 사라짐 -->
      <div
        class="absolute right-0 top-0 bottom-px w-14 bg-linear-to-r from-transparent to-white/95 pointer-events-none flex items-center justify-end pr-1 transition-opacity duration-300 lg:hidden"
        [class.opacity-0]="!hasMoreTabs()">
        <app-icon name="material-symbols:chevron-right-rounded" class="size-6! text-primary-500" />
      </div>
    </div>
  </div>

  <!-- 컨텐츠 영역 -->
  <section>
    @if (selectedTab() === 'promotion') {
    <div class="flex flex-col gap-12 lg:gap-15 px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-8 lg:py-12 w-full">
      <!-- Promotional plan 타이틀 -->
      <div class="text-center flex flex-col gap-4">
        <p class="sb-aggro text-zinc-500 text-sm lg:text-base">Promotional plan</p>
        <h1 class="text-2xl lg:text-4xl text-zinc-800">홍보 계획</h1>
      </div>

      <!-- 카드 컴포넌트 (데이터 포함) -->
      <app-promotion-card class="max-w-3xl mx-auto" />
    </div>

    <section class="flex flex-col gap-10">
      <!-- 배경 이미지 -->
      <div class="relative w-full">
        <img src="/event/middle-bg-pc.png" alt="중간 배경" class="w-full h-81.5 hidden lg:flex object-cover" />
        <img src="/event/middle-bg-mo.png" alt="중간 배경" class="w-full flex lg:hidden object-cover" />
        <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 gap-4">
          <p class="sb-aggro text-white custom-text-shadow">ON AIR</p>
          <h1 class="text-white text-2xl lg:text-4xl">특별방송 효과 및 현장</h1>
        </div>
      </div>

      <!-- 비디오 영역 -->
      @if (latestVideoData(); as video) {
      <div class="flex w-full container">
        <div class="aspect-video w-full max-w-4xl mx-auto">
          <app-gallery-video-player [src]="youtubeEmbedUrl()" class="w-full h-full rounded-3xl" />
        </div>
      </div>
      } @else {
      <!-- 비디오 데이터가 없을 때 -->
      <div class="flex w-full py-6 lg:py-10 lg:container">
        <div class="aspect-video w-full max-w-4xl mx-auto bg-zinc-100 rounded-lg flex items-center justify-center">
          <p class="text-zinc-400 text-sm lg:text-base">영상을 준비중입니다.</p>
        </div>
      </div>
      }

      <app-sketch class="w-full bg-zinc-50" [isEventPage]="true" />
    </section>
    } @if (selectedTab() === 'application') {
    <app-guide-plan />
    } @if (selectedTab() === 'preparation') {
    <app-preparation-schedule />
    } @if (selectedTab() === 'faq') {
    <div class="px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-8 lg:py-12 w-full flex flex-col gap-10">
      <div class="text-center flex flex-col gap-4">
        <p class="sb-aggro text-zinc-500 text-sm lg:text-base">FAQ</p>
        <h1 class="text-2xl lg:text-4xl text-zinc-800">자주 묻는 질문</h1>
      </div>
      <app-participant-faq />
    </div>
    }
  </section>
</main>
